module.exports = vendor_d48489dabb0c9f88363b;